var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSm01Search(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80413 1.5C12.8316 1.5 16.1076 4.776 16.1076 8.8035C16.1076 10.7037 15.3784 12.4367 14.1851 13.7374L16.5332 16.0805C16.7529 16.3003 16.7537 16.6558 16.5339 16.8755C16.4244 16.9865 16.2797 17.0413 16.1357 17.0413C15.9924 17.0413 15.8484 16.9865 15.7382 16.877L13.3618 14.5073C12.1117 15.5084 10.5266 16.1077 8.80413 16.1077C4.77663 16.1077 1.49988 12.831 1.49988 8.8035C1.49988 4.776 4.77663 1.5 8.80413 1.5ZM8.80413 2.625C5.39688 2.625 2.62488 5.39625 2.62488 8.8035C2.62488 12.2108 5.39688 14.9827 8.80413 14.9827C12.2106 14.9827 14.9826 12.2108 14.9826 8.8035C14.9826 5.39625 12.2106 2.625 8.80413 2.625Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm01Search);
export default __webpack_public_path__ + "static/media/SM01-search.87771f1bc0dbe944b23582e3d6c20f60.svg";
export { ForwardRef as ReactComponent };